const formatPath = (path) => {
  if (path.includes("/")) {
    const splitted = path.split("/");
    return splitted[splitted.length - 1];
  }
  return path;
};
export { formatPath };
